import { onMounted, onBeforeUnmount, watch } from 'vue'
import { useStore } from 'vuex'

const MICROSITE_ADD_TO_CART = 'DOCUMOTO_ADD_TO_CART'

export function useMicrositeAddToCart (iframe, micrositeUrl, isWidget) {
  const store = useStore()
  let generation = 0
  let pending = Promise.resolve()
  const received = new Set()

  function reset () {
    generation++
    received.clear()
    pending = Promise.resolve()
  }

  function onMessage (event) {
    const message = event.data
    if (!iframe.value || event.source !== iframe.value.contentWindow ||
        message?.type !== MICROSITE_ADD_TO_CART ||
        typeof message.actionId !== 'string' || !message.actionId.trim()) return

    // Widget srcdoc inherits the parent origin; normal Microsites use their entry URL.
    const origin = isWidget.value
      ? window.location.origin
      : new URL(micrositeUrl.value, window.location.href).origin
    if (event.origin !== origin || received.has(message.actionId)) return
    received.add(message.actionId)

    const current = generation
    const source = event.source
    const isCurrent = () => current === generation && iframe.value?.contentWindow === source
    pending = pending
      .then(() => {
        if (!isCurrent()) return false
        const { partNumber, supplier, quantity } = message
        return store.dispatch('cart/addFromMicrosite', { partNumber, supplier, qty: quantity, isCurrent })
      })
      .catch(() => {})
  }

  watch([micrositeUrl, isWidget], reset, { flush: 'sync' })
  onMounted(() => window.addEventListener('message', onMessage))
  onBeforeUnmount(() => {
    reset()
    window.removeEventListener('message', onMessage)
  })
}
